import {
    policyTipsFalsePositive,
    policyTipsOverride,
} from './getPolicyTipsInfoBarMessage.locstring.json';
import loc from 'owa-localize';
import { getHighestPriorityPolicyTipMatchDetail } from './getHighestPriorityPolicyTipMatchDetail';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import DlpPolicyMatchDetail from 'owa-service/lib/contract/DlpPolicyMatchDetail';
import DlpPolicyTipAction from 'owa-service/lib/contract/DlpPolicyTipAction';

export function getPolicyTipsInfoBarMessage(policyTipsViewState: PolicyTipsViewState): string {
    const matchDetail: DlpPolicyMatchDetail = getHighestPriorityPolicyTipMatchDetail(
        policyTipsViewState.succeededPolicyMatch
    );
    if (matchDetail) {
        if (!policyTipsViewState.isOverridden && !policyTipsViewState.isReportedFalsePositive) {
            if (matchDetail.PolicyTipMessage) {
                return matchDetail.PolicyTipMessage;
            }
            switch (matchDetail.Action) {
                case DlpPolicyTipAction.NotifyOnly:
                case DlpPolicyTipAction.RejectUnlessFalsePositiveOverride:
                    return policyTipsViewState.notifyString;
                    break;
                case DlpPolicyTipAction.RejectUnlessSilentOverride:
                case DlpPolicyTipAction.RejectUnlessExplicitOverride:
                    return policyTipsViewState.overrideString;
                    break;
                case DlpPolicyTipAction.RejectMessage:
                    return policyTipsViewState.blockString;
                    break;
            }
        } else if (policyTipsViewState.isReportedFalsePositive) {
            return loc(policyTipsFalsePositive);
        } else if (policyTipsViewState.isOverridden) {
            return loc(policyTipsOverride);
        }
    }
    return '';
}
